import React from 'react';
import { ArrowUpRight, Heart, Sparkles } from 'lucide-react';

const heartsForMissionsImage = require('./heartsformissions.png');
const transformationCollectiveImage = require('./thetransformationcollective.png');

const initiatives = [
  {
    eyebrow: 'Women’s empowerment',
    title: 'The Transformation Collective',
    description: 'A sacred community where women are equipped, encouraged, and supported as they grow in faith, wellness, leadership, and purpose.',
    href: 'https://www.thetransformationcollective.org',
    cta: 'Explore the Collective',
    image: transformationCollectiveImage,
    icon: Sparkles,
    theme: 'from-[#25152d] via-[#45213d] to-[#25152d]',
    accent: 'text-[#e3bb3a]',
    button: 'bg-[#d9b230] text-[#25152d] hover:bg-[#efd26c]',
  },
  {
    eyebrow: 'Global medical service',
    title: 'Hearts for Missions',
    description: 'Join a compassionate movement bringing medical service, meaningful connection, and lasting community impact to Ghana’s Western Region.',
    href: 'https://heartsformissions.org',
    cta: 'Discover the Mission',
    image: heartsForMissionsImage,
    icon: Heart,
    theme: 'from-[#27171a] via-[#63212e] to-[#27171a]',
    accent: 'text-[#f3a3af]',
    button: 'bg-[#d92345] text-white hover:bg-[#b91938]',
  },
];

export default function InitiativeShowcase() {
  return (
    <section className="bg-[#eeece7] py-16 sm:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-8 max-w-3xl sm:mb-10">
          <p className="mb-4 text-sm font-semibold uppercase tracking-[0.22em] text-primary">Beyond our walls</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-foreground">
            Our <span className="text-primary italic">Programs</span> &amp; Services
          </h2>
          {/* <h2 className="font-heading text-4xl font-bold leading-tight text-foreground sm:text-5xl">Communities of purpose, service, and transformation.</h2> */}
          <p className="mt-5 text-lg leading-relaxed text-muted-foreground">Explore two initiatives extending Rose of Jericho’s heart for whole-person wellness and meaningful community impact.</p>
        </div>

        <div className="grid gap-8 lg:grid-cols-2">
          {initiatives.map((initiative) => {
            const Icon = initiative.icon;
            return (
              <article key={initiative.title} className={`group relative isolate overflow-hidden rounded-[1.75rem] bg-gradient-to-br ${initiative.theme} p-1 shadow-xl transition-transform duration-300 hover:-translate-y-1`}>
                <div className="relative h-full overflow-hidden rounded-[1.5rem] bg-black/20">
                  <img src={initiative.image} alt={`${initiative.title} initiative`} className="h-64 w-full object-cover object-center opacity-95 transition duration-500 group-hover:scale-105 group-hover:opacity-0 sm:h-72" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/25 to-black/10" />
                  <div className="absolute inset-x-0 bottom-0 p-7 sm:p-9">
                    <div className={`mb-4 inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.18em] ${initiative.accent}`}><Icon className="h-4 w-4" aria-hidden="true" />{initiative.eyebrow}</div>
                    <h3 className="relative -z-20 font-heading text-3xl font-bold text-white sm:text-4xl">{initiative.title}</h3>
                    <p className="relative -z-20 mt-3 max-w-xl leading-relaxed text-white/80">{initiative.description}</p>
                    <a href={initiative.href} target="_blank" rel="noopener noreferrer" className={`mt-6 inline-flex items-center gap-2 rounded-full px-5 py-3 text-sm font-semibold transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white ${initiative.button}`}>
                      {initiative.cta}<ArrowUpRight className="h-4 w-4" aria-hidden="true" />
                    </a>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
